import { render, staticRenderFns } from "./FilePreviewVideo.vue?vue&type=template&id=c797d188&"
import script from "./FilePreviewVideo.vue?vue&type=script&lang=js&"
export * from "./FilePreviewVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports